import React, { Component } from 'react'
import { connect } from 'react-redux'

import lang from 'lang'
import styles from './document-export-email-modal.css'
import SendIcon from '@assets/images/icons/email.svg'
import Loader from '@/modules/base/components/loader/loader'
import { ModalBig } from '@/modules/base/components/modal/index'
import { TextInput, TextareaInput, EmailTagInput } from '@/modules/base/components/inputs/index'
import { sendDocumentExport, closeEmailModal } from '@/redux/ducks/documentExport/list'
import { CancelButton, ButtonIconSquare } from '@/modules/base/components/buttons/index'

const defaultExport = {
  recipients: [],
  subject: '',
  text: '',
}

class DocumentExportEmailModal extends Component {
  constructor(props) {
    super(props)

    const { selectedExport = defaultExport, taxAccountant } = props
    const { exportPeriod } = selectedExport
    const { email } = taxAccountant

    const text = `Sehr geehrte Damen und Herren,\n\nanbei sende ich Ihnen meine Buchführungsunterlagen für den Zeitraum ${exportPeriod} zu.\n\nMit freundlichen Grüßen`

    this.state = {
      recipients: email ? [email] : [],
      subject: `Buchungs-Unterlagen ${exportPeriod}`,
      text,
    }

    this.handleSendClick = this.handleSendClick.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
  }

  handleSendClick(event) {
    event.preventDefault()
    if (this.checkForm()) return

    const { sendDocumentExport, selectedExport: { id } } = this.props
    const { recipients, subject, text } = this.state

    sendDocumentExport(id, { recipients, subject, text })
  }

  handleInputChange(value, name) {
    this.setState({ [name]: value })
  }

  checkForm() {
    const { recipients, subject } = this.state

    return !recipients.length || !subject
  }

  render() {
    const { open, isLoading, closeEmailModal } = this.props
    const { subject, recipients, text } = this.state

    const formInvalid = this.checkForm()
    const actions = [
      <CancelButton
        type='button'
        label='Abbrechen'
        tabIndex={-1}
        onClick={closeEmailModal} />,
      <ButtonIconSquare
        type='submit'
        label='Senden'
        icon={SendIcon}
        disabled={formInvalid}
        customClass={styles.sendButton}
        onClick={this.handleSendClick} />,
    ]

    return (
      <ModalBig
        classes={{ paper: styles.modal }}
        open={open}
        actions={actions}
        title={lang.documentExport.sendModalTitle}
        onClose={closeEmailModal}>
        <Loader visible={isLoading} customClass={styles.loader} />
        <div className={styles.content}>
          <form onSubmit={this.handleSendClick}>
            <div className={styles.inputs}>
              <TextInput
                required
                label='Betreff*'
                name='subject'
                value={subject}
                onChange={this.handleInputChange} />
              <EmailTagInput
                required
                label='E-Mail-Adressen*'
                name='recipients'
                emails={recipients}
                onChange={this.handleInputChange} />
              <TextareaInput
                label='Nachrichtentext'
                name='text'
                value={text}
                rows={6}
                onChange={this.handleInputChange} />
            </div>
          </form>
        </div>
      </ModalBig>
    )
  }
}

const mapStateToProps = (state) => {
  const {
    documentExport: {
      list: {
        isModalLoading,
        taxAccountant,
      },
    },
  } = state

  return {
    isLoading: isModalLoading,
    taxAccountant,
  }
}

const mapDispatchToProps = (dispatch) => ({
  sendDocumentExport: (id, data) => dispatch(sendDocumentExport(id, data)),
  closeEmailModal: () => dispatch(closeEmailModal()),
})

export default connect(mapStateToProps, mapDispatchToProps)(DocumentExportEmailModal)
